
require('../../sass/mgm/asynchronous.scss');
require('../../sass/base/base.scss');
let util = require('../common/util');
let ajax = require('../common/ajax/ajax.js');
let docomchannel = require('./common/dochannel');
import toast from '../../components/toast/toast.vue';
import { changeTitle, getParam } from '../common/util'
import MobileDetect from 'mobile-detect';
changeTitle('88元红包限时领');
let md = new MobileDetect(window.navigator.userAgent);
let ua = detector.parse(navigator.userAgent);
/* eslint-disable */
var __interval;
/* eslint-enable */
let weixinflag = util.isWeiXin()
let bdocpc = require('./common/bd-ocpc.js');
// import interceptor from '../common/interceptors';
// interceptor();
window.onload = function() {
  util.closeLoading();
};
let errorMsg = '很抱歉,网络异常,请稍后重试';
new Vue({
  el: '#bd',
  components: {
    [toast.name]: toast
  },
  data: {
    loading: true,
    isShowForm: false,
    phone: '', // 手机号
    codeObj: {
      code: '', // 验证码
      isGetCode: false, //正在获取验证码
      getCodeMsg: '获取验证码' //获取验证码提示
    },
    passcodeTag: '', // passcode标记
    submitIng: false, //正在提交注册
    regResultObj: {
      show: false,
      exist: false
    },
    downloadIng: false,
    paramsObj: undefined,
    btnShow: false,
    appChannel: getParam('appChannel') || 'MGMwx01'
  },
  ready() {
    if (weixinflag) {
      let url = location.href
      if (url.indexOf('referralCode') >= 0) {
        url = url.replace('referralCode', 'preReferralCode')
      }
      let param = {
        title: '您有30天免息券待领取，立即领取>>',
        des: '好友已为你开通优先审批特权，最高可借50000元！',
        url: url,
        success: this.callback,
        business: GLOBAL_URL.ROOT_MGM_PRODUCTION,
        img: GLOBAL_URL.ROOT_MGM + '/mobile/statics/img/mgm/log.png'
      };
      weixin(true, param);
      // 在微信
    }

    let paramsObj = this.paramsObj || this.getParamsObj();
    if (paramsObj.appChannel === 'weimi16') {
      bdocpc({
        paramChannel: paramsObj.appChannel,
        targetChannel: 'weimi16',
        guid: 'tpl_udf_22294350_extra',
        siteid: 166601,
        pageid: 172398,
        ucid: 24351027
      });
    }
    // 用于下载的链接this.downloadChannel
    this.downloadChannel = docomchannel.getAppChannel(paramsObj.appChannel, ['xhqb01']);
    this.loading = false
  },
  created() {
    xhTrack.log.onload('asynchronous', '记录首次访问时间', true);
  },
  methods: {
    openForm: function() {
      xhTrack.log.onload('asynchronous', '打开注册', true);
      this.isShowForm = true
    },
    closeForm: function() {
      this.isShowForm = false
    },
    //验证手机号码
    _verifyPhone: function(phone) {
      if (!phone) {
        this.$refs.toast.show('请输入手机号码！');
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) {
        this.$refs.toast.show('请输入正确的手机号码！');
      } else {
        return true;
      }
      return false;
    },
    //验证验证码
    _verifyCode: function(code) {
      let errMsg;
      if (!this.passcodeTag) {
        errMsg = '请先获取验证码';
      } else if (!code) {
        errMsg = '请输入验证码！';
      } else if (code.length < 6) {
        errMsg = '请输入6位验证码！';
      }
      if (errMsg) {
        this.$refs.toast.show(errMsg);
        xhTrack.track('verify-fail', 'verify-fail', '表单验证失败', errMsg);
        return false;
      } else {
        return true;
      }
    },
    //60秒倒计时
    _countdown: function() {
      let that = this
      let i = 60;
      that.codeObj.isGetCode = true;
      that.codeObj.getCodeMsg = (i + '秒后发送');
      var __interval1 = setInterval(function() {
        i--;
        if (i <= 0) {
          that._resetCountdown();
          clearInterval(__interval1);
        } else {
          that.codeObj.getCodeMsg = (i + '秒后发送');
        }
      }, 1000);
    },
    //重置倒计时
    _resetCountdown: function() {
      this.codeObj.isGetCode = false;
      this.codeObj.getCodeMsg = '获取验证码';
    },
    getParamsObj: function() {
      //注册所需传送字段
      let deviceID = util.storage.get('fppDeviceId') ? util.storage.get('fppDeviceId') : Guid.create().value;
      //兼容无痕模式，防止报错  原因：兼容无痕模式操作cookie会报错
      try {
        util.storage.set('fppDeviceId', deviceID, {expires: 30, path: '/'});
      } catch (e) {}

      let deviceType = ua.device.family;
      let appChannel = util.getParam('appChannel');
      let appPostChannel = appChannel;
      let invitationChannel = util.getParam('invitationChannel');
      let invitationPostChannel = invitationChannel;

      let deviceName = ua.device.name;
      let clientPlatform = ua.os.family;
      let brand = ua.device.manufacturer;
      let osversion = ua.os.version;

      //浏览器分辨率
      let devicePixelRatio = window.devicePixelRatio;
      let screen = window.screen;
      let resolution = (screen.width * devicePixelRatio) + 'X' + (screen.height * devicePixelRatio);
      let channelName = 'WEB';

      //请求验证码及注册传递参数
      let paramsObj = {
        deviceID: deviceID,
        deviceType: deviceType,
        invitationChannel: invitationPostChannel,
        appChannel: appPostChannel,
        deviceName: deviceName,
        clientPlatform: clientPlatform,
        brand: brand,
        osversion: osversion,
        resolution: resolution,
        channelName: channelName
      };

      // 添加注册referral_type
      /* eslint-disable */
      let invitationCode = util.getParam('invitationCode');
      /* eslint-enable */
      // var referralCode = util.getParam('referralCode');
      paramsObj['referralType'] = 'MGM01'
      this.paramsObj = paramsObj;
      return paramsObj;
    },
    toGetCode: function(e) {
      // 点击获取状态码
      // 获取验证码
      let that = this
      /* eslint-disable */
      let phone, code;
      phone = that.phone;
      code = that.code;
      /* eslint-enable */
      //重复点击验证码
      if (that.codeObj.isGetCode) {
        xhTrack.trackClick({
          target: e.target,
          label: '获取验证码(重复点击)-按钮',
          property: 'btn-verify',
        });
        return;
      }
      let paramsObj = that.paramsObj || that.getParamsObj();
      xhTrack.trackClick({
        target: e.target,
        label: '获取验证码-按钮',
        property: 'btn-verify',
      });
      if (!that.codeObj._isGetCode && that._verifyPhone(phone)) {
        __interval = that._countdown();
        ajax.toPost({
          vm: that,
          url: '/auth/genToken',
          params: $.extend({
            phoneNum: phone,
            bizType: 'register'
          }, paramsObj),
          success: function(dataToken) {
            let dataTokenIn = dataToken.data;
            if (dataTokenIn.success) {
              ajax.toPost({
                vm: that,
                url: '/auth/pass/sendRegisterPass',
                params: $.extend({
                  phoneNum: phone,
                  bizType: 'register'
                }, paramsObj),
                headers: {
                  token: dataToken.headers.token
                },
                success: function(datas) {
                  let data = datas.data;
                  that.passcodeTag = data.passcodeTag;
                  if (data.success) {
                    if (data.resultMsg === '成功') {
                      that.$refs.toast.show('验证码发送成功！');
                      xhTrack.track('captcha-success', 'captcha-success', '获取验证码成功');
                    } else {
                      that.$refs.toast.show(data.resultMsg);
                      xhTrack.track('captcha-fail', 'captcha-fail', '获取验证码失败', data.resultMsg);
                    }
                  } else {
                    that.$refs.toast.show(data.resultMsg || errorMsg);
                    that._resetCountdown();
                  }
                },
                error: function() {
                  that.$refs.toast.show(errorMsg);
                  that._resetCountdown();
                  xhTrack.track('captcha-fail', 'captcha-fail-error', '获取验证码失败-网络异常', errorMsg);
                }
              })
            } else {
              that.$refs.toast.show(dataTokenIn.resultMsg || '获取验证码token失败', 2000);
              that._resetCountdown();
              xhTrack.track('captcha-fail', 'captcha-fail-error', '获取验证码token失败', dataTokenIn.resultMsg);
            }
          }
        });
      }
    },
    toRegister: function(e) {
      // 点击注册
      if (this.btnShow) {
        this.$refs.toast.show('请先阅读并勾选协议');
        return;
      }
      // 提交注册
      let that = this;
      let phone = that.phone;
      let code = that.codeObj.code;
      let passcodeTag = that.passcodeTag;
      //获取邀请码
      let invitationCode = util.getParam('invitationCode');
      let sourceEntry = util.getParam('sourceEntry');
      let paramsObj = that.paramsObj || that.getParamsObj();
      //若重复提交
      if (that.submitIng) {
        xhTrack.trackClick({
          target: e.target,
          label: '立即注册(重复提交表单)-按钮',
          property: 'btn-reg',
        });
        return;
      }
      that.submitIng = true;
      xhTrack.trackClick({
        target: e.target,
        label: '立即注册(提交表单)-按钮',
        property: 'btn-reg',
      });
      if (that._verifyPhone(phone) && that._verifyCode(code)) {
        ajax.toPost({
          vm: that,
          url: '/auth/user/register',
          params: $.extend({
            phoneNum: phone,
            smsPasscode: code,
            passcodeTag: passcodeTag,
            invitationCode: invitationCode,
            sourceEntry: sourceEntry
          }, paramsObj),
          success: function(datas) {
            let data = datas.data;
            if (data.success) {
              that._resetCountdown()
              //$('.result-old').addClass('hidden');
              //$('.result-new').removeClass('hidden');
              that.regResultObj.exist = false;
              that.regResultObj.show = true;
              that.hasReg = true
              that.submitIng = false;
              xhTrack.track('submit-success', 'submit-success-new', '提交注册成功');
            } else {
              if (data.resultMsg === '用户已存在，请登录') {
                //that.hasReg = true
                that._resetCountdown();
                //$('.result-new').addClass('hidden');
                //$('.result-old').removeClass('hidden');
                that.regResultObj.exist = true;
                that.regResultObj.show = true;
                that.submitIng = false;
                xhTrack.track('submit-success', 'submit-success-already', '提交注册成功-用户已存在');
              } else {
                that.$refs.toast.show(data.resultMsg, 2000);
                that.submitIng = false;
                xhTrack.track('submit-fail', 'submit-fail', '提交注册失败', data.resultMsg);
              }
            }
          },
          error: function(resp) {
            that.$refs.toast.show(resp.data.errorDescription || errorMsg);
            that.submitIng = false;
            xhTrack.track('submit-fail', 'submit-fail-error', '提交注册失败-网络异常', errorMsg);
          }
        });

      } else {
        that.submitIng = false;
      }
    },
    toDownload: function(e) {
      let that = this;
      let appChannel = util.getParam('appChannel');
      //bdTrack.fpp('统计', '下载统计', appChannel);
      xhTrack.track('xhpopulrz推广统计', '下载统计', appChannel, that.downloadChannel, weixinflag);
      if (that.downloadIng) {
        xhTrack.trackClick({
          target: e.target,
          label: '下载(重复点击)-按钮',
          property: 'btn-download',
        });
        return;
      }
      util.showLoading();
      that.downloadIng = true;

      xhTrack.trackClick({
        target: e.target,
        label: '下载-按钮',
        property: 'btn-download',
      });
      setTimeout(function() {
        if (md.os() === 'iOS') {
          location.href = 'https://itunes.apple.com/app/id1050915215';
        } else if (weixinflag || md.match(/\sQQ/i)) {
          location.href = GLOBAL_URL.ROOT + '/mobile/xhpopulrz/download-app.html';
        } else if (md.os() === 'AndroidOS') {
          location.href = 'https://s3.cn-north-1.amazonaws.com.cn/app-download/Android/prod/' + that.downloadChannel + '.apk';
        } else {
          location.href = GLOBAL_URL.ROOT + '/mobile/xhpopulrz/download-app.html?appChannel=MGMwx01';
        }
      }, 200);

      //2秒后才允许再次点击下载
      setTimeout(function() {
        that.downloadIng = false;
        util.closeLoading();
      }, 2000);
    },
    blurfns: function(e) {
      //微信IOS12以上版本微信弹出键盘底下空白
      if (weixinflag && md.os() === 'iOS' && ua.os.version > 12) {
        window.scroll(0, 0);
      }
    },
    focusfns: function(e) {
      //微信IOS12以上版本微信弹出键盘底下空白
      if (weixinflag && md.os() === 'iOS' && ua.os.version > 12) {
        window.scroll(0, 184);
      }
    },
    requestFriend() {
      // 点击了参与邀请好友
      location.href = GLOBAL_URL.ROOT_MGM + '/mobile/mgm/index.html?appChannel=' + this.appChannel;
    },
    checkboxOnclick() {
      this.btnShow = !this.btnShow;
    },
    //分享成功后的回调，用来插入分享记录数据
    callback() {
      // this.$http.post(GLOBAL_URL.ROOT + '/h5api/marketapi/mgm/getInviteCode', {
      //   activityUrl: `${location.protocol}//${document.domain}/mobile/mgm/index.html?appChannel=${this.appChannel}`,
      //   recommendResult: 'success',
      // }).then(resp => {
      //   const data = resp.json();
      //   if (data.success) {
      //     // 分享成功
      //   } else {
      //     this.loading = false;
      //   }
      // });
      let self = this;
      ajax.newPost({
        vm:self,
        url: GLOBAL_URL.ROOT + '/h5api/marketapi/mgm/getInviteCode', 
        params:{
          businessGroup: 'BGALL',
          activityUrl: `${location.protocol}//${document.domain}/mobile/mgm/index.html?appChannel=${self.appChannel}`,
          recommendResult: 'success'
        },
        success:function(res){
          let data = res.data;
          if (data.success) {
            // 分享成功
          } else {
            self.loading = false;
          }
        },
        error:function(error){
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./web/js/mgm/asynchronous.js